/** Partner codes that mean a successful read with no usage — not a load failure. */
export const EMPTY_PARTNER_CODES = new Set(["no_whatsapp_channels", "no_daily_volume", "no_schema"]);

const ERROR_MESSAGE_KEYS = {
  deadline: "platformPage.waDailyBoardErrorTimeout",
  query_error: "platformPage.waDailyBoardErrorQuery",
  partner_unavailable: "platformPage.waDailyBoardErrorUnavailable",
  db_unreachable: "platformPage.waDailyBoardErrorUnavailable",
  rate_limited: "platformPage.waDailyBoardErrorRateLimited",
  chunk_failed: "platformPage.waDailyBoardErrorNetwork",
  chunk_missing: "platformPage.waDailyBoardErrorGeneric",
  usage_fail: "platformPage.waDailyBoardErrorUnavailable",
  auth_fail: "platformPage.waDailyBoardErrorAuth",
  partner_login_failed: "platformPage.waDailyBoardErrorAuth",
  partner_app_token_failed: "platformPage.waDailyBoardErrorAuth",
  missing_partner_credentials: "platformPage.waDailyBoardErrorCredentials",
  missing_partner_app_id: "platformPage.waDailyBoardErrorCredentials",
  missing_app_id: "platformPage.waDailyBoardErrorCredentials",
};

export function resolveWorkspaceLoadState(hit) {
  if (hit?.partner_ok) return { status: "ok" };
  const code = String(hit?.partner_code || "").trim();
  if (EMPTY_PARTNER_CODES.has(code)) return { status: "empty" };
  return { status: "error" };
}

export function workspaceStatusRank(status) {
  if (status === "error") return 0;
  if (status === "ok") return 1;
  if (status === "empty") return 2;
  return 3;
}

export function sortBoardRows(rows) {
  return [...rows].sort((a, b) => {
    const rankA = workspaceStatusRank(a.status);
    const rankB = workspaceStatusRank(b.status);
    if (rankA !== rankB) return rankA - rankB;
    const av = Number(a.projected_amount_brl);
    const bv = Number(b.projected_amount_brl);
    const aOk = Number.isFinite(av);
    const bOk = Number.isFinite(bv);
    if (aOk && bOk && bv !== av) return bv - av;
    if (aOk !== bOk) return aOk ? -1 : 1;
    return String(a.dominio).localeCompare(String(b.dominio), "pt-BR");
  });
}

export function summarizeBoardRows(rows) {
  let ok = 0;
  let empty = 0;
  let error = 0;
  let pending = 0;
  for (const row of rows) {
    if (row.status === "ok") ok += 1;
    else if (row.status === "empty") empty += 1;
    else if (row.status === "error") error += 1;
    else pending += 1;
  }
  return {
    ok,
    empty,
    error,
    pending,
    resolved: ok + empty,
    finished: ok + empty + error,
    total: rows.length,
  };
}

export function workspaceErrorI18nKey(code) {
  return ERROR_MESSAGE_KEYS[String(code || "")] || "platformPage.waDailyBoardErrorGeneric";
}

export function emptyWorkspaceI18nKey(code) {
  if (code === "no_whatsapp_channels") return "platformPage.waDailyBoardNoChannel";
  if (code === "no_schema") return "platformPage.waDailyBoardNoSchema";
  return "platformPage.waDailyBoardUnavailable";
}

export function failedWorkspaceIds(rows) {
  return rows.filter((row) => row.status === "error").map((row) => row.dominio_id);
}
